/* eslint-disable */
// @ts-nocheck

import { Fragment } from 'react'

import { Image as Logo, StyleSheet, Text, View } from '@react-pdf/renderer'

import defaultLogo from '@/assets/image-default.jpg'

import APIMediaServer from '../api/APIMediaServer'
import DocumentHeader from '../components/pdf/DocumentHeader'
import DocumentPage from '../components/pdf/DocumentPage'
import TableTemplate from '../components/pdf/TableTemplate'
import {
  BusinessInterface,
  RegisterBillingInterface,
} from '../interfaces/ServerInterfaces'
import { formatCurrency, formatDateForTable } from '../utils/helpers'
import { translateOrderOrigin, translateOrderState } from '../utils/translate'
import { blobToDataURL } from './helpers/commons'

interface PdfSelledInterface {
  orders: RegisterBillingInterface[]
  filters: { dateFrom: string | Date; dateTo: string | Date }
  business: BusinessInterface | null
}

const styles = StyleSheet.create({
  logoContainer: {
    flexBasis: '50%',
    alignItems: 'flex-start',
  },
  businessLogo: {
    height: 85.4,
    objectFit: 'contain',
    paddingLeft: 0.9,
  },
})
const getBusinessLogo = async (logoId: number) => {
  try {
    const response = await APIMediaServer.get('/files/' + logoId, {
      responseType: 'blob',
    })
    return (await blobToDataURL(response.data)) as string
  } catch (error) {
    console.error(error)
    return defaultLogo
  }
}

const BillingOrderListPdf = ({
  orders,
  filters,
  business,
}: PdfSelledInterface) => {
  return (
    <DocumentPage>
      <Logo
        src={business?.logo ? getBusinessLogo(business?.logo?.id) : ''}
        style={styles.businessLogo}
      />
      <DocumentHeader subtext={''} text="Reporte de facturas" />
      <Fragment>
        <TableTemplate
          containTotals
          data={orders.map((item, idx) => {
            return {
              Tipo: !item?.isPreReceipt ? 'Factura' : 'Pre-Factura',
              'No.': !item?.isPreReceipt
                ? item.operationNumber
                : item.preOperationNumber,
              Cliente: `${item.client?.firstName ?? ''} ${item.client?.lastName ?? ''}`,
              Estado: translateOrderState(item.status),
              Emisión: formatDateForTable(item?.createdAt),
              Origen: translateOrderOrigin(item.origin),
              Importe: item.totalToPay
                .map(
                  (total) =>
                    `${formatCurrency(total.amount, total.codeCurrency === 'CUL' ? 'CUP' : total.codeCurrency)}`
                )
                .join(' '),
            }
          })}
          tableName={'Facturas'}
        />
      </Fragment>
    </DocumentPage>
  )
}

export default BillingOrderListPdf
